import React, { Component } from "react"
import { connect } from 'react-redux'
import { saveTransactionAction } from '../../redux/actions/MainAction'
import $ from 'jquery'

import { msg } from '../../components/Notifications/MsgBox';

import {
    clearSearchDirectoryInfoAction,
} from '../../redux/actions/MasterAction'
import {
    setKeyValueAction as setKeyValueEmployeeModalAction,
    clearModalAction as clearEmployeeModalAction,
} from '../../redux/actions/ModalEmployeeAction'

import {
    setKeyValueAction as setKeyValueVendorModalAction,
    clearModalAction as clearVendorModalAction,
} from '../../redux/actions/ModalVendorAction'

import {
    updateEvaluationModalAction,
    clearEvaluationModalAction,
    updateMR_VendorAction,
    clearMR_VendorAction,
} from '../../redux/actions/MRAction'


import { Input, Select } from "../core"

class ConsortiumModal extends Component {

    constructor(props) {
        super(props)

        this.state = {
            ...props,
        }


        this.handleChange = this.handleChange.bind(this)
        this.onSaveHandler = window._.debounce(this.onSaveHandlerdelay, 300);   //this.onSaveHandler.bind(this)
    }

    searchEmployeeModal(empCode, empName) {

        this.props.clearSearchDirectoryInfo();
        this.props.clearEmployeeModal();

        this.props.setKeyValueEmployeeModal('T_MR_VENDOR', empCode, empName)

        window.$('#searchEmployeeModal').modal('show');

    }

    searchVendorModal(vendorCode, vendorName) {

        //this.props.clearSearchDirectoryInfo();
        this.props.clearVendorModal();

        this.props.setKeyValueVendorModal('T_MR_VENDOR', vendorCode, vendorName)

        window.$('#searchVendorModal').modal('show');
    }

    formatDisplayEmployee(empCode, empName) {
        if (empCode !== null && empCode !== '')
            return `${empName} (${empCode})`
        else
            return ''
    }

    formatDisplayVendor(vendorCode, vendorName) {
        if (vendorCode !== null && vendorCode !== '')
            return `${vendorCode} ${vendorName}`
        else
            return ''
    }

    openVendor() {
        let { t_MR_DETAIL } = this.props;

        if (t_MR_DETAIL.evaluation_type === "consortium_evaluation") {

            this.searchVendorModal("vendor_code", "vendor_name")
        }
    }

    componentDidUpdate() {
        console.log('ConsortiumModal:componentDidUpdate')
    }

    componentWillReceiveProps() {
        console.log('ConsortiumModal:componentWillReceiveProps')
    }

    handleChange(event) {
       
        const { mrForms, mrVendortypes } = this.props

        const target = event.target
        const name = target.name
        const value = target.value
        let desc = '' //target.selectedOptions[0].label
        if (name === "evaluation_form_name") {

            let mrformdesc = mrForms.find(f=>f.forM_ID == value)
            desc = mrformdesc ? mrformdesc.forM_NAME : ''

            this.props.updateEvaluationModal({
                ...this.props.evaluationModal,
                [name]: value,
                ['evaluation_form_name_desc']: desc
            });

        } else if (name === "vendor_group") {

            let mrVendortypesdesc = mrVendortypes.find(f => f.vendoR_TYPE_CODE == value)
            desc = mrVendortypesdesc ? mrVendortypesdesc.vendoR_TYPE_NAME : ''

            this.props.updateEvaluationModal({
                ...this.props.evaluationModal,
                [name]: value,
                ['vendor_group_desc']: desc
            });
        } else {
            this.props.updateEvaluationModal({
                ...this.props.evaluationModal,
                [name]: value
            });

        }
    }



    onSaveHandlerdelay = (e) => {
        e.preventDefault();
        if (this.validateBeforeSave() === false) {
            msg.error("กรุณาป้อนข้อมูลให้ครบถ้วน")
        }
        else {
            let { evaluationModal } = this.props
            this.props.updateMR_Vendor(evaluationModal, evaluationModal.index);
            window.$('#addConsortiumModal').modal('hide');
        }
    }

    onCancleHandler() {

    }

    validateBeforeSave() {
        try {
            let { evaluationModal } = this.props

            if (evaluationModal.vendor_code === null
                || evaluationModal.vendor_code === '')
                return false
            if (evaluationModal.evaluation_form_name === null
                || evaluationModal.evaluation_form_name === ''
                || evaluationModal.evaluation_form_name === '0'
                || evaluationModal.evaluation_form_name === 0)
                return false
            // if (evaluationModal.vendor_group === null
            //     || evaluationModal.vendor_group === '')
            //     return false
            if (evaluationModal.evaluator_id === null
                || evaluationModal.evaluator_id === '')
                return false
        }
        catch (error) {
            return false
        }

        return true
    }

    render() {
        console.log("ConsortiumModal.render()")

        let { evaluationModal, t_MR_DETAIL } = this.props

        //: {this.props.evaluationModal.vendor_name}

        return (
            <div className="modal fade sp-modal rrs-modal" id="addConsortiumModal" tabIndex={-1} role="dialog" aria-labelledby="addConsortiumModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addConsortiumModalLabel">
                                {evaluationModal.index === "" ? 'เพิ่ม ' : 'แก้ไข'}
                            </h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body rrs-container">
                            <div className="rrs-detail3">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="rrs-form">
                                            <label htmlFor="a3" className="rrs-label"><span className="required">*</span> Vendor Code</label>
                                            <div className="rrs-detail-data">
                                                <Input
                                                    type="text"
                                                    className="form-control form-control-search-2 w-100"
                                                    id="a3"
                                                    value={this.formatDisplayVendor(evaluationModal.vendor_code, evaluationModal.vendor_name)}
                                                    onClick={() => this.openVendor()}
                                                    readOnly={true}
                                                    viewMode={t_MR_DETAIL.evaluation_type !== null && evaluationModal.index === "" && t_MR_DETAIL.evaluation_type === "genaral_evaluation"}
                                                    disabled={t_MR_DETAIL.evaluation_type !== null  && t_MR_DETAIL.evaluation_type === "genaral_evaluation"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="rrs-form d-block">
                                            <label htmlFor="a1" className="rrs-label"><span className="required">*</span> ใช้ชุดแบบสอบถาม</label>
                                            <div className="rrs-detail-data">

                                                <Select
                                                    name="evaluation_form_name"
                                                    value={evaluationModal.evaluation_form_name}
                                                    onChange={this.handleChange}
                                                    className="w-100"
                                                >
                                                    {this.props.mrForms && this.props.mrForms.map((data, index) => (
                                                        (
                                                            (t_MR_DETAIL.is_new_evaluation===(data.forM_TYPE==="New" ? true :false)
                                                              && ( (t_MR_DETAIL.is_enrgy === true ? true : false) === (data.iS_ENERGY==="N" ? false :true) )
                                                              && ( (t_MR_DETAIL.is_enrgy === null ? false : true) === (data.iS_SEPARATION_PLANT==="N" ? false :true) )
                                                        ) || data.forM_ID===0) &&
                                                        (
                                                            <option
                                                                key={index}
                                                                value={data.forM_ID}>
                                                                {data.forM_NAME} 
                                                                {/* {"form : "+data.forM_ID} 
                                                                {" t_MR_DETAIL.is_enrgy : "+(t_MR_DETAIL.is_enrgy === true ? true : false)}
                                                                {" data.iS_ENERGY : "+(data.iS_ENERGY==="N" ? false :true)}
                                                                {" data.iS_SEPARATION_PLANT : "+(data.iS_SEPARATION_PLANT==="N" ? false :true)}
                                                                {" = : "+(false===true)} */}
                                                            </option>
                                                        )
                                                    ))}

                                                </Select>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="rrs-form d-block">
                                            <label htmlFor="a2" className="rrs-label">กลุ่มทะเบียนผู้ค้า</label>
                                            <div className="rrs-detail-data">

                                                <Select
                                                    name="vendor_group"
                                                    value={evaluationModal.vendor_group}
                                                    onChange={this.handleChange}
                                                    className="w-100"
                                                >
                                                    {this.props.mrVendortypes && this.props.mrVendortypes.map((vendortype, index) => (
                                                        (
                                                            <option
                                                                key={index}
                                                                value={vendortype.vendoR_TYPE_CODE}>
                                                                {vendortype.vendoR_TYPE_NAME}
                                                            </option>
                                                        )
                                                    ))}

                                                </Select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12">
                                        <div className="rrs-form">
                                            <label htmlFor="a3" className="rrs-label"><span className="required">*</span> ผู้ประเมิน</label>
                                            <div className="rrs-detail-data">

                                                <Input
                                                    //name="receiver_name"
                                                    value={this.formatDisplayEmployee(evaluationModal.evaluator_id, evaluationModal.evaluator_name)}
                                                    className="form-control form-control-search-2"
                                                    //id="receiver_name"
                                                    //onBlur={this.handleChange}
                                                    onClick={() => this.searchEmployeeModal("evaluator_id", "evaluator_name")}
                                                    readOnly={true}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mx-0 header-button-row mt-5">
                                    <div className="col-12 sp-header-button-panel2">
                                        <div className="col-12 sp-header-button-panel2">
                                            <a  className="sp-btn-icon btn-del" data-dismiss="modal" onClick={this.onCancleHandler}>
                                                <i className="icon btn-order-delete"></i><span className="sp-btn-icon-label">Close</span>
                                            </a>
                                            <a  className="sp-btn-icon" onClick={this.onSaveHandler}>
                                                <i className="icon btn-order-savedraft"></i><span className="sp-btn-icon-label">Save</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { MainRedux, MasterRedux } = state
    return {
        transaction: MainRedux.transaction,
        evaluationModal: MainRedux.evaluationModal,
        mrForms: MasterRedux.mrForms,
        mrVendortypes: MasterRedux.mrVendortypes,
        t_MR_DETAIL: MainRedux.t_MR_DETAIL,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        saveTransaction: (transaction) => dispatch(saveTransactionAction(transaction)),
        clearSearchDirectoryInfo: () => dispatch(clearSearchDirectoryInfoAction()),
        setKeyValueEmployeeModal: (table, empCode, empName) => dispatch(setKeyValueEmployeeModalAction(table, empCode, empName)),
        clearEmployeeModal: () => dispatch(clearEmployeeModalAction()),
        setKeyValueVendorModal: (table, empCode, empName) => dispatch(setKeyValueVendorModalAction(table, empCode, empName)),
        clearVendorModal: () => dispatch(clearVendorModalAction()),
        updateMR_Vendor: (data, index) => dispatch(updateMR_VendorAction(data, index, '')),
        updateEvaluationModal: (data) => dispatch(updateEvaluationModalAction(data)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ConsortiumModal)